import { render } from "./CarouselB.vue?vue&type=template&id=79e78108&scoped=true"
import script from "./CarouselB.vue?vue&type=script&lang=js"
export * from "./CarouselB.vue?vue&type=script&lang=js"

import "./CarouselB.vue?vue&type=style&index=0&id=79e78108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e78108"]])

export default __exports__